/*
 * @Description: 一周用户情感倾向趋势-条形图
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 10:59:40
 * @LastEditTime: 2021-01-07 10:45:12
 */

const axis = ['顺意群体', '中立群体', '逆意群体'];

const createSeries = (name, color, list) => ({
  name: name,
  type: 'bar',
  stack: '总量',
  label: {
    normal: {
      formatter: (item) => {
        return item.value > 0 ? item.value : ''
      },
      show: list.length <= 10,
      position: 'insideRight'
    }
  },
  itemStyle: {
    normal: {
      color: color
    }
  },
  data: list
})



/**
 * 修改数据按月分组
 * @param {*} data 
 */
export const formatMonth = (data) => {
  // -------------------------------数据按月算- begin-------------------------------

  const map = {},
        days = new Set()
  data.dateList.forEach((date, index) => {
    const name = date.replace(/-\d{2}$/, '')
    days.add(name)
    if (typeof map[name] === 'undefined') {
      map[name] = {
        betterList: 0,
        worseList: 0,
        neList: 0
      }
    }
    map[name].betterList += data.betterList[index]
    map[name].worseList += data.worseList[index]
    map[name].neList += data.neList[index]
  })

  let result = {
    dateList: [],
    betterList: [],
    worseList: [],
    neList: []
  }
  days.forEach(name => {
    const { betterList, worseList, neList } = map[name]
    result.dateList.push(name)
    result.betterList.push(betterList)
    result.worseList.push(worseList)
    result.neList.push(neList)
  })
  
  return result
}

const emotionalTendencyBar = (data) => {

  const _data = formatMonth(data)
  
  return {
    tooltip : {
        trigger: 'axis',
        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    legend: {
      show: true,
      data: axis
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis:  {
        type: 'value',
        position:'top'
    },
    yAxis: {
        type: 'category',
        data: _data.dateList.reverse()
    },
    series: [
      createSeries('顺意群体', '#f7b1b2', _data.betterList.reverse()),
      createSeries('中立群体', '#ffd70d', _data.neList.reverse()),
      createSeries('逆意群体', '#4fb7ed', _data.worseList.reverse())
    ]
  };

}

export default emotionalTendencyBar;


// WEBPACK FOOTER //
// src/chart/emotionalTendencyBar.js